import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false


import router from './router'
import store from './store/index'

import ElementUI from 'element-ui'
Vue.use(ElementUI)
// import './assets/style/fonts.css'
// import './assets/style/element-variables.scss'

import cookie from 'vue-cookie'
Vue.prototype.$cookie = cookie;

import { setMenuList } from './utils/index'
let menuList = JSON.parse(localStorage.getItem('menuList')) 
store.state.menuList = setMenuList(menuList) 



//全局方法挂载
import { hasPermission } from '@/utils/index.js'
Vue.prototype.$_has = hasPermission

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
